<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

//

import { ListDataInterface } from "@/types/ContentType";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const props = defineProps<{
  content: ListDataInterface;
}>();
</script>

<template>
  <section>
    <div class="type-card d-flex dir-col">
      <div class="type-card__image pos-rel">
        <Picture
          :devices="content.image?.[0]?.devices"
          imgClass="img-absolute"
          alt="apartment type"
        />
      </div>
      <div class="type-card__inner d-flex dir-col al-center">
        <div class="type-card__inner-area d-flex">
          <p class="hl-2-light">{{ content?.area }}</p>
          <p class="type-card__inner-area-msquared p-12 uppercase">{{ $t("m") }}</p>
          <sup>2</sup>
        </div>
        <div class="type-card__inner-type uppercase p-14">
          <p>{{ content?.title }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss"></style>
